import { type SupplierMdfQualificationStatusDto } from '../../types/supplier/supplier-mdf-qualification-status-dto.type';
import { EntityStatusModel } from '../entity-status.model';

export class SupplierMdfQualificationStatusModel extends EntityStatusModel {
  readonly isFullyMatch: boolean;

  constructor(data: SupplierMdfQualificationStatusDto) {
    super(data);

    this.isFullyMatch = data.isFullyMatch;
  }
}
